import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CredentialsInfo = ({ language }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const translations = {
    fr: {
      title: 'Identifiants de test',
      showCredentials: 'Afficher les identifiants',
      hideCredentials: 'Masquer les identifiants',
      lawyer: 'Avocat',
      secretary: 'Secrétaire',
      admin: 'Administrateur',
      email: 'E-mail',
      password: 'Mot de passe'
    },
    ar: {
      title: 'بيانات الاختبار',
      showCredentials: 'إظهار بيانات الاعتماد',
      hideCredentials: 'إخفاء بيانات الاعتماد',
      lawyer: 'محامي',
      secretary: 'سكرتير',
      admin: 'مدير',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور'
    }
  };

  const t = translations?.[language];

  const credentials = [
    { role: t?.lawyer, email: 'avocat@legaloffice.ma', password: 'Lawyer@2026' },
    { role: t?.secretary, email: 'secretaire@legaloffice.ma', password: 'Secretary@2026' },
    { role: t?.admin, email: 'admin@legaloffice.ma', password: 'Admin@2026' }
  ];

  return (
    <div className="mt-6 md:mt-8 p-4 md:p-6 bg-accent/5 border border-accent/20 rounded-lg">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between w-full text-left"
      >
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="Info" size={20} className="text-accent" />
          <span className="text-sm md:text-base font-semibold text-foreground">{t?.title}</span>
        </div>
        <Icon
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          className="text-muted-foreground"
        />
      </button>
      {isExpanded && (
        <div className="mt-4 space-y-3 md:space-y-4">
          {credentials?.map((cred, index) => (
            <div key={index} className="p-3 md:p-4 bg-background rounded-lg border border-border">
              <p className="text-sm font-semibold text-foreground mb-2">{cred?.role}</p>
              <div className="space-y-1.5">
                <div className="flex items-start gap-2">
                  <span className="text-xs text-muted-foreground min-w-[60px] md:min-w-[80px]">{t?.email}:</span>
                  <code className="text-xs font-mono text-foreground bg-muted px-2 py-1 rounded">
                    {cred?.email}
                  </code>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-xs text-muted-foreground min-w-[60px] md:min-w-[80px]">{t?.password}:</span>
                  <code className="text-xs font-mono text-foreground bg-muted px-2 py-1 rounded">
                    {cred?.password}
                  </code>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CredentialsInfo;